import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../index"
import type { CartProduct } from "./cartSlice"

export interface UTMs {
	utm_source: string | null
	utm_medium?: string | null
	utm_campaign?: string | null
	utm_term?: string | null
	utm_content?: string | null
}

export interface UrlState {
	params: string | null
	utms: UTMs
	products: CartProduct[]
	treatment: string | null
}

const initialState: UrlState = {
	params: null,
	utms: {
		utm_source: null,
		utm_medium: null,
		utm_campaign: null,
		utm_term: null,
		utm_content: null
	},
	products: [],
	treatment: null
}

export const urlSlice = createSlice({
	name: "url",
	initialState,
	reducers: {
		updateUtms: (state, action: PayloadAction<UTMs>) => {
			state.utms = action.payload
		}
	}
})

export const { updateUtms } = urlSlice.actions

export default urlSlice.reducer

export const selectUTMs = (state: RootState): UTMs => state.url.utms
